"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Style = exports.Grid = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _createBreakpoints = _interopRequireWildcard(require("./createBreakpoints"));
var _variables = _interopRequireDefault(require("../style/variables"));
var _injectSheet = _interopRequireDefault(require("../style/injectSheet"));
var _excluded = ["alignContent", "alignItems", "classes", "className", "component", "container", "direction", "item", "justify", "lg", "md", "sm", "spacing", "theme", "wrap", "xl", "xs", "zeroMinWidth"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /*:: // 

import { type ElementType } from 'react';*/
/*:: import { type InjectSheetProvidedProps } from '../style/ThemeTypes';*/
var BASE = _variables.default.base;
var GUTTERS = [0, 8, 16, 24, 32, 40];
var GRID_SIZES = ['auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
var generateGrid = function generateGrid(globalStyles, breakpoint) {
  var styles = {};
  GRID_SIZES.forEach(function (size) {
    var key = "grid-".concat(breakpoint, "-").concat(String(size));
    if (size === true) {
      // For the auto layouting
      styles[key] = {
        flexBasis: 0,
        flexGrow: 1,
        maxWidth: '100%'
      };
      return;
    }
    if (size === 'auto') {
      styles[key] = {
        flexBasis: 'auto',
        flexGrow: 0,
        maxWidth: 'none'
      };
      return;
    }

    // Only keep 6 significant numbers.
    var width = "".concat(Math.round(size / 12 * 10e6) / 10e4, "%");

    // Close to the bootstrap implementation:
    // https://github.com/twbs/bootstrap/blob/8fccaa2439e97ec72a4b7dc42ccc1f649790adb0/scss/mixins/_grid.scss#L41
    styles[key] = {
      flexBasis: width,
      flexGrow: 0,
      maxWidth: width
    };
  });

  // No need for a media query for the first size.
  if (breakpoint === 'xs') {
    Object.assign(globalStyles, styles);
  } else {
    globalStyles[(0, _createBreakpoints.default)({}).up(breakpoint)] = styles;
  }
};
var generateGutter = function generateGutter(breakpoint) {
  var styles = {};
  GUTTERS.forEach(function (spacing, index) {
    if (index === 0) {
      // Skip the default style.
      return;
    }
    styles["spacing-".concat(breakpoint, "-").concat(spacing)] = {
      margin: "".concat(-spacing / 2 / BASE, "rem"),
      width: "calc(100% + ".concat(spacing / BASE, "rem)"),
      '& > $item': {
        padding: "".concat(spacing / 2 / BASE, "rem")
      }
    };
  });
  return styles;
};

/**
 * Default CSS values
 * flex: '0 1 auto',
 * flexDirection: 'row',
 * alignItems: 'flex-start',
 * flexWrap: 'nowrap',
 * justifyContent: 'flex-start'
 */
var Style = exports.Style = function Style() {
  return _objectSpread(_objectSpread({
    /* Styles applied to the root element if `container={true}`. */
    container: {
      boxSizing: 'border-box',
      display: 'flex',
      flexWrap: 'wrap',
      width: '100%'
    },
    /* Styles applied to the root element if `item={true}`. */
    item: {
      boxSizing: 'border-box',
      margin: 0 // For instance, it's useful when used with a `figure` element.
    },
    /* Styles applied to the root element if `zeroMinWidth={true}`. */
    zeroMinWidth: {
      minWidth: 0
    },
    /* Styles applied to the root element if `direction="column"`. */
    'direction-xs-column': {
      flexDirection: 'column'
    },
    /* Styles applied to the root element if `direction="column-reverse"`. */
    'direction-xs-column-reverse': {
      flexDirection: 'column-reverse'
    },
    /* Styles applied to the root element if `direction="rwo-reverse"`. */
    'direction-xs-row-reverse': {
      flexDirection: 'row-reverse'
    },
    /* Styles applied to the root element if `wrap="nowrap"`. */
    'wrap-xs-nowrap': {
      flexWrap: 'nowrap'
    },
    /* Styles applied to the root element if `wrap="reverse"`. */
    'wrap-xs-wrap-reverse': {
      flexWrap: 'wrap-reverse'
    },
    /* Styles applied to the root element if `alignItems="center"`. */
    'align-items-xs-center': {
      alignItems: 'center'
    },
    /* Styles applied to the root element if `alignItems="flex-start"`. */
    'align-items-xs-flex-start': {
      alignItems: 'flex-start'
    },
    /* Styles applied to the root element if `alignItems="flex-end"`. */
    'align-items-xs-flex-end': {
      alignItems: 'flex-end'
    },
    /* Styles applied to the root element if `alignItems="baseline"`. */
    'align-items-xs-baseline': {
      alignItems: 'baseline'
    },
    /* Styles applied to the root element if `alignContent="center"`. */
    'align-content-xs-center': {
      alignContent: 'center'
    },
    /* Styles applied to the root element if `alignContent="flex-start"`. */
    'align-content-xs-flex-start': {
      alignContent: 'flex-start'
    },
    /* Styles applied to the root element if `alignContent="flex-end"`. */
    'align-content-xs-flex-end': {
      alignContent: 'flex-end'
    },
    /* Styles applied to the root element if `alignContent="space-between"`. */
    'align-content-xs-space-between': {
      alignContent: 'space-between'
    },
    /* Styles applied to the root element if `alignContent="space-around"`. */
    'align-content-xs-space-around': {
      alignContent: 'space-around'
    },
    /* Styles applied to the root element if `justify="center"`. */
    'justify-xs-center': {
      justifyContent: 'center'
    },
    /* Styles applied to the root element if `justify="flex-end"`. */
    'justify-xs-flex-end': {
      justifyContent: 'flex-end'
    },
    /* Styles applied to the root element if `justify="space-between"`. */
    'justify-xs-space-between': {
      justifyContent: 'space-between'
    },
    /* Styles applied to the root element if `justify="space-around"`. */
    'justify-xs-space-around': {
      justifyContent: 'space-around'
    },
    /* Styles applied to the root element if `justify="space-evenly"`. */
    'justify-xs-space-evenly': {
      justifyContent: 'space-evenly'
    }
  }, generateGutter('xs')), _createBreakpoints.keys.reduce(function (accumulator, key) {
    // Use side effect over immutability for better performance.
    generateGrid(accumulator, key);
    return accumulator;
  }, {}));
};
/*:: type GridSizes = false | 'auto' | true | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;*/
/*:: type Props = InjectSheetProvidedProps & {
  /**
   * Defines the `align-content` style property.
   * It's applied for all screen sizes.
   *-/
  alignContent: 'stretch' | 'center' | 'flex-start' | 'flex-end' | 'space-between' | 'space-around',  // eslint-disable-line prettier/prettier
  /**
   * Defines the `align-items` style property.
   * It's applied for all screen sizes.
   *-/
  alignItems: 'flex-start' | 'center' | 'flex-end' | 'stretch' | 'baseline',
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   *-/
  component: ElementType,
  /**
   * If `true`, the component will have the flex *container* behavior.
   * You should be wrapping *items* with a *container*.
   *-/
  container: boolean,
  /**
   * Defines the `flex-direction` style property.
   * It is applied for all screen sizes.
   *-/
  direction: 'row' | 'row-reverse' | 'column' | 'column-reverse',
  /**
   * If `true`, the component will have the flex *item* behavior.
   * You should be wrapping *items* with a *container*.
   *-/
  item: boolean,
  /**
   * Defines the `justify-content` style property.
   * It is applied for all screen sizes.
   *-/
  justify: 'flex-start' | 'center' | 'flex-end' | 'space-between' | 'space-around' | 'space-evenly',  // eslint-disable-line prettier/prettier
  /**
   * Defines the number of grids the component is going to use.
   * It's applied for the `lg` breakpoint and wider screens if not overridden.
   *-/
  lg: GridSizes,
  /**
   * Defines the number of grids the component is going to use.
   * It's applied for the `md` breakpoint and wider screens if not overridden.
   *-/
  md: GridSizes,
  /**
   * Defines the number of grids the component is going to use.
   * It's applied for the `sm` breakpoint and wider screens if not overridden.
   *-/
  sm: GridSizes,
  /**
   * Defines the space between the type `item` component.
   * It can only be used on a type `container` component.
   *-/
  spacing: 0 | 8 | 16 | 24 | 32 | 40,
  /**
   * Defines the `flex-wrap` style property.
   * It's applied for all screen sizes.
   *-/
  wrap: 'nowrap' | 'wrap' | 'wrap-reverse',
  /**
   * Defines the number of grids the component is going to use.
   * It's applied for the `xl` breakpoint and wider screens.
   *-/
  xl: GridSizes,
  /**
   * Defines the number of grids the component is going to use.
   * It's applied for all the screen sizes with the lowest priority.
   *-/
  xs: GridSizes,
  /**
   * If `true`, it sets `min-width: 0` on the item.
   * Refer to the limitations section of the documentation to better understand the use case.
   *-/
  zeroMinWidth: boolean
};*/
// eslint-disable-line prettier/prettier
var _Grid = exports.Grid = function Grid(props /*: Props*/) {
  var _classNames;
  var alignContent = props.alignContent,
    alignItems = props.alignItems,
    classes = props.classes,
    classNameProp = props.className,
    Component = props.component,
    container = props.container,
    direction = props.direction,
    item = props.item,
    justify = props.justify,
    lg = props.lg,
    md = props.md,
    sm = props.sm,
    spacing = props.spacing,
    theme = props.theme,
    wrap = props.wrap,
    xl = props.xl,
    xs = props.xs,
    zeroMinWidth = props.zeroMinWidth,
    other = (0, _objectWithoutProperties2.default)(props, _excluded);
  var className = (0, _classnames.default)((_classNames = {}, (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_classNames, classes.container, container), classes.item, item), classes.zeroMinWidth, zeroMinWidth), classes["spacing-xs-".concat(String(spacing))], container && spacing !== 0), classes["direction-xs-".concat(String(direction))], direction !== _Grid.defaultProps.direction), classes["wrap-xs-".concat(String(wrap))], wrap !== _Grid.defaultProps.wrap), classes["align-items-xs-".concat(String(alignItems))], alignItems !== _Grid.defaultProps.alignItems), classes["align-content-xs-".concat(String(alignContent))], alignContent !== _Grid.defaultProps.alignContent), classes["justify-xs-".concat(String(justify))], justify !== _Grid.defaultProps.justify), classes["grid-xs-".concat(String(xs))], xs !== false), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_classNames, classes["grid-sm-".concat(String(sm))], sm !== false), classes["grid-md-".concat(String(md))], md !== false), classes["grid-lg-".concat(String(lg))], lg !== false), classes["grid-xl-".concat(String(xl))], xl !== false)), classNameProp);
  return /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({
    className: className,
    "data-testid": "grid"
  }, other));
};
_Grid.displayName = 'Grid';
_Grid.defaultProps = {
  alignContent: 'stretch',
  alignItems: 'stretch',
  component: 'div',
  container: false,
  direction: 'row',
  item: false,
  justify: 'flex-start',
  lg: false,
  md: false,
  sm: false,
  spacing: 0,
  wrap: 'wrap',
  xl: false,
  xs: false,
  zeroMinWidth: false
};
var _default = exports.default = (0, _injectSheet.default)(Style)(_Grid);
//# sourceMappingURL=Grid.js.map